import { ClaimsTriggerType } from '../types/triggers.type';

export interface IClaimMailPayload {
  asset: string;
  email: string;
  insurer: string;
  user_id: string;
  brolink_id: string;
  policy_id: string;
  broker_email: string;
  trigger: ClaimsTriggerType;
}

export interface IReferralMailPayload {
  user_id: number;
  preferred_name: string;
  email: string;
  surname: string;
}

export interface IMandateViolationMailPayload {
  quotes_id: number;
}

export interface IClaimMailPayload {
    asset: string,
    insurer: string,
    user_id: string,
    brolink_id: string,
    policy_id: string
    claim_reason?: string;
    trigger: ClaimsTriggerType;
}

export interface IHolidayViolationMailPayload {
  quotes_id: number;
}
